// apps/web/src/lib/painel/home/saudacao.ts — Fase 17.8, Plano 04 (D-10; UI-SPEC U-03).
// Peças puras do cabeçalho da home: primeiro nome e data longa (eyebrow) no fuso operacional.
import { TIMEZONE_OPERACIONAL } from '../../dia-operacional';

/** Primeira palavra do nome de exibição; sem nome, o usuário (login); sem nenhum, vazio. */
export function primeiroNome(displayName: string, username: string): string {
  const nome = displayName.trim().split(/\s+/)[0] ?? '';
  return nome !== '' ? nome : username.trim();
}

const FORMATO_DATA = new Intl.DateTimeFormat('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', timeZone: TIMEZONE_OPERACIONAL });

/** 'Terça-feira, 13 de outubro': data longa em America/Sao_Paulo, inicial maiúscula, sem o ano. */
export function dataLongaCapitalizada(agora: Date): string {
  const texto = FORMATO_DATA.format(agora);
  return texto.charAt(0).toLocaleUpperCase('pt-BR') + texto.slice(1);
}
